<template>
    <div class="message-item__content--swiper-list">
        <div class="swiper-list">
            <div class="swiper__tabs">
                <swiper ref="listSwiperComponent" :options="swiperOptions">
                    <swiper-slide
                        class="swiper__item"
                        v-for="(item, index) in swiperList"
                        :key="index">
                        <div
                            :class="[
                                'swiper__inner',
                                { 'active-tab' : index === activeIndex }
                            ]"
                            :style="{'--color': index === activeIndex && color}"
                            @click="clickTab(index)">
                            {{item.name}}
                        </div>
                    </swiper-slide>
                    <div class="swiper-button-prev" slot="button-prev"
                        v-show="(swiperList.length > 1) && swiperIsOver">
                        <span class="navigation__icon icon_arrow-right"></span>
                    </div>
                    <div class="swiper-button-next" slot="button-next"
                        v-show="(swiperList.length > 1) && swiperIsOver">
                        <span class="navigation__icon icon_arrow-right"></span>
                    </div>
                </swiper>
            </div>
            <div class="swiper__content">
                <div class="guide_img" :style="{'--color': color}">
                    <div class="action"
                        v-if="currentOptions.length > OPTION_COUNT_LIMIT"
                        @click="nextPage">
                        <div class="action__icon icon_change" :style="{'--color': color}"></div>
                        <div class="action__name" :style="{'--color': color}">换一批</div>
                    </div>
                </div>
                <div
                    :class="[
                        'option__list',
                        { 'has-bottom-border' : filterOptions.length < OPTION_COUNT_LIMIT}
                    ]">
                    <div class="option__item"
                        v-for="(option, $i) in filterOptions"
                        :key="$i"
                        :style="{'--color': color}"
                        @click="clickItem(option)">
                        <div class="option__name">{{option.text}}</div>
                        <span class="option__icon icon_arrow-right"></span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { sendMessage } from '@/utils/message_send'
    import { MESSAGE_NAME } from '@/constants/message'
    import { paging } from '@/utils'

    const OPTION_COUNT_LIMIT = 5

    let ListSwiper = null // swiper实例

    export default {
        name: 'MessageContentSwiperList',
        props: {
            swiperList: {
                type: Array,
                required: true
            }
        },
        data () {
            return {
                swiperOptions: {
                    observer: true,
                    observeParents: true,
                    slidesPerView: 'auto',
                    spaceBetween: 15,
                    navigation: {
                        nextEl: '.swiper-button-next',
                        prevEl: '.swiper-button-prev',
                        disabledClass: 'swiper-button-disabled'
                    }
                },
                swiperIsOver: false, // 是否超出容器

                activeIndex: 0, // 当前项索引
                pageNum: 0,
                OPTION_COUNT_LIMIT
            }
        },
        computed: {
            currentOptions () { // 当前所有项
                return this.swiperList[this.activeIndex].options || []
            },
            filterOptions () { // 当前分页项
                return paging(this.currentOptions, this.pageNum, OPTION_COUNT_LIMIT)
            },
            theme () {
                return this.$eventBus.theme
            },
            color () {
                if (this.theme === 'white') {
                    return this.$store.state.theme.color
                }
                return this.$store.state.lingkeColor
            }
        },
        watch: {
            activeIndex () {
                this.pageNum = 0
            }
        },
        methods: {
            clickTab (index) {
                this.activeIndex = index
            },
            clickItem ({ text }) {
                sendMessage({
                    type: 'base',
                    detailType: MESSAGE_NAME.TEXT,
                    content: text
                })
                this.$eventBus.$emit('showinputstatus', {is_input:true})
            },
            nextPage () {
                this.pageNum += 1

                const optionsLength = this.currentOptions.length
                const totalPage = Math.ceil(optionsLength / OPTION_COUNT_LIMIT)

                if (this.pageNum >= totalPage) {
                    this.pageNum = 0
                }
            },
            swiperComputed () {
                this.$nextTick(() => {
                    ListSwiper = this.$refs.listSwiperComponent.swiper
                    let slides = Array.from(ListSwiper.slides)
                    let slideWidth = slides.reduce((sum, curr) => {
                        return sum + curr.clientWidth + 15
                    }, 0)
                    slideWidth += 15 // 第一项有左外边距15px
                    this.swiperIsOver = slideWidth > ListSwiper.width
                })
            }
        },
        mounted () {
            this.swiperComputed()

            window.onresize = () => {
                this.swiperComputed()
            }
        },
        beforeDestroy () {
            window.onresize = () => {}
        }
    }
</script>

<style lang="scss" scoped>
    @import "../../css/option_list.scss";

    .swiper-list {
        width: percentForService(295);
        height: 238px;
        // height: 200px;
        font-size: 14px;
        color: $primary-text-color;
        background-color: #FFFFFF;
        box-shadow: $primary-box-shadow;
        overflow: hidden;
        @include radius(.5);

        @include desktop {
            width: 560px;
        }

        @include iphone4 { // 兼容320的
            width: 245px;
        }
        .action__icon,
        .action__name {
            color: var(--color);
        }
    }

    /deep/ .swiper-container {
        border-bottom: 1px solid #E1E2E4;

        .swiper-wrapper {
            display: flex;
            height: 39px;
        }
    }

    .swiper {
        &__tabs {
            height: 40px;
        }

        &__item {
            width: auto;

            &:first-child {
                margin-left: 15px;
            }
        }

        &__inner {
            color: #919294;
            line-height: 39px;
            cursor: pointer;
            position: relative;

            &.active-tab {
                // color: $primary-color;
                color: var(--color);
                font-weight: 600;
                &::after {
                    content: '';
                    height: 1px;
                    width: 100%;
                    // background: $primary-color;
                    background: var(--color);
                    position: absolute;
                    bottom: 0;
                    left: 0;
                    right: 0;
                }
            }
        }

        &__content {
            height: calc(100% - 40px);
            display: flex;

            .guide_img {
                width: 60px;
                height: 100%;
                // height: 160px;
                background: url("./img/guide.svg") 50% 60% no-repeat;
                background-size: cover;
                position: relative;
                background-color: var(--color);
            }

            .action {
                position: absolute;
                bottom: 3px;
                left: 0;
                right: 0;
                color: $primary-color;
                text-align: center;
                cursor: pointer;

                &__name {
                    font-size: 12px;
                    line-height: 1.5;
                    // line-height: (20 / 12);
                }

                &__icon {
                    font-size: 13px;
                    margin-bottom: 2px;
                }
            }
        }
    }

    .option {
        &__list {
            flex: 1;
            overflow: hidden;

            &.has-bottom-border {
                .option__item {
                    &:last-child {
                        border-bottom: 1px solid #E1E2E4;
                    }
                }
            }
        }
    }
</style>
